export default __webpack_public_path__ + "static/media/average.9b225b2d.svg";